const labels: Readonly<Record<string, string>> = {
  dispatched: 'ส่งพัสดุออกแล้ว',
  in_transit: 'พัสดุอยู่ระหว่างขนส่ง',
  carrier_delivered: 'ขนส่งรายงานว่าส่งถึงแล้ว',
  delivery_failed: 'ขนส่งรายงานว่านำส่งไม่สำเร็จ',
  returned: 'พัสดุถูกส่งคืน',
  customer_received: 'ลูกค้าบันทึกว่ารับพัสดุแล้ว',
  shared: 'แชร์สถานะพัสดุให้ลูกค้าแล้ว',
};
export function deliveryEventLabel(event: string) {
  return labels[event] ?? 'เหตุการณ์พัสดุที่บันทึกไว้';
}
export function deliveryEventTime(value: string) {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return 'ยังไม่ทราบเวลา';
  return (
    new Intl.DateTimeFormat('th-TH', {
      timeZone: 'Asia/Bangkok',
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(date) + ' (เวลาไทย UTC+7)'
  );
}
